import style from "./index.module.css";

const LoadingSkeleton = ({
  width = "100% !important",
  count,
  margin = "auto !important",
  height,
}: componentProps) => {
  const counts = new Array(count).fill(1);

  return (
    <div className={style.skeleton} style={{ width, margin }}>
      {counts.map((item, index) => (
        <div key={index} style={{ height }}></div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;

type componentProps = {
  count: number;
  width?: string;
  margin?: string;
  height?: string;
};
